import { Mail, Linkedin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-neutral-800 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="w-2 h-2 bg-[#36C281] inline-block" />
            <span className="font-serif-display text-2xl">Rob Power</span>
          </div>
          <p className="text-neutral-500 text-sm tracking-[0.25em] uppercase">Buyers Agent · Investing Nationally · Supporting Locally</p>
          <p className="text-neutral-400 mt-6 leading-relaxed max-w-sm">
            Independent property buying for investors who value process over promises.
          </p>
        </div>

        <div>
          <p className="overline mb-6">Reach Out</p>
          <ul className="space-y-3 text-neutral-300">
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#36C281]" />
              <a
                href="mailto:rob@iscoutproperty.com.au"
                data-testid="footer-email-link"
                className="hover:text-[#36C281] transition-colors"
              >
                rob@iscoutproperty.com.au
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#36C281]" />
              <a
                href="tel:+61449844097"
                data-testid="footer-phone-link"
                className="hover:text-[#36C281] transition-colors"
              >
                0449 844 097
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Linkedin size={16} className="text-[#36C281]" />
              <a
                href="https://www.linkedin.com/in/robert-power-336a5a175/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin-link"
                className="hover:text-[#36C281] transition-colors"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="overline mb-6">Navigate</p>
          <ul className="space-y-3 text-neutral-300">
            <li><a href="/#results" className="hover:text-[#36C281] transition-colors">Previous Acquisitions</a></li>
            <li><a href="/#testimonials" className="hover:text-[#36C281] transition-colors">Testimonials</a></li>
            <li><a href="/#services" className="hover:text-[#36C281] transition-colors">Services</a></li>
            <li><a href="/#contact" className="hover:text-[#36C281] transition-colors">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-neutral-500">
          <span>© {new Date().getFullYear()} Rob Power · iScout Property. All rights reserved.</span>
          <span>Built on data. Backed by discipline.</span>
        </div>
      </div>
    </footer>
  );
}
